import { DesperfectosEditorComponent } from './../desperfectos-editor/desperfectos-editor.component';
import { VehicleDipositDto } from './../../Models/diposit-vehicle.model';
import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { DipositGruaService } from '../../services/diposit-grua-service';
import { DesperfectosDto } from '../../Models/desperfectosDto';
import { MatDialog, MatDialogRef } from '@angular/material';
import { PhotoBoxGruaComponent } from '../photo-box-grua/photo-box-grua.component';
import { DenunciesImagesComponent } from 'app/sections/denuncies/components/denuncies-editor/components/denuncies-images/denuncies-images.component';

@Component({
  selector: 'app-diposit-grua-desperfectos',
  templateUrl: './diposit-grua-desperfectos.component.html',
  styleUrls: ['./diposit-grua-desperfectos.component.scss']
})
export class DipositGruaDesperfectosComponent implements OnInit {
  
  denunciesImages: any = [];
  denunciesImageDialogRef: MatDialogRef<DenunciesImagesComponent>;
  val: VehicleDipositDto;
  desperfectos: DesperfectosDto[];
  @Input() get value() {
    return this.val;
  } set value(val) {
    this.val = val;
    setTimeout(() => {
      this.valueChange.emit(this.val);
    }, 10);
  }
  @Output() valueChange = new EventEmitter();

  displayedColumns: string[] = ['FechaHora', 'Descripcio','imatges', 'action'];
  constructor(
    private dipositService: DipositGruaService,
    private dialog: MatDialog, ) { }

  ngOnInit() {
    this.loadDesperfectos();

  }
  loadDesperfectos() {
    if (this.value.secureId !== undefined && this.value.secureId !== null && this.value.secureId !== '') {
      this.dipositService.getDesperfectos(this.value.secureId).subscribe(res => {
        if ( res !== undefined && res !== null) {
          this.desperfectos = res;
        } else {
          this.desperfectos = [];
        }
      });
    }
  }
  openDialog(action, obj) {
    if (obj !== undefined && obj !== null && action !== 'Add') {
      this.dipositService.getImages(obj.SomId,this.value.iddenuncia).subscribe( images => {
        obj.IMATGES = images;
        obj.action = action;
        obj.iddenuncia = this.value.iddenuncia;
        //obj.idDipositVehicle = this.value.idDipositVehicle;
        const dialogRef = this.dialog.open(DesperfectosEditorComponent, {
          width: '70%',
          height: '80%',
          closeOnNavigation: false,
          autoFocus: true,
          data: obj
        });

        dialogRef.afterClosed().subscribe(result => {
          this.loadDesperfectos();
         /* if (result.event === 'Add') {
            this.setDesperfecto(result.data);
          } else if (result.event === 'Update') {
            this.setDesperfecto(result.data);
          } else if (result.event === 'Delete') {
            this.deleteDesperfecto(result.data);
          }*/
        });
      });
    }else if( action === 'Add'){
      obj.action = action;
      obj.idDipositVehicle = this.value.idDipositVehicle;
      const dialogRef = this.dialog.open(DesperfectosEditorComponent, {
        width: '70%',
        height: '30%',
        closeOnNavigation: false,
        autoFocus: true,
        data: obj
      });

      dialogRef.afterClosed().subscribe(result => {
        this.loadDesperfectos();
      });
    }

  }

  /*onRowClicked(row) {
    if (row !== undefined && row !== null) {
      this.denunciesService.getDenunciaImagesNumDen(row.iddenuncia).subscribe( images => {
        row.IMATGES = images;
        const ref = this.dialog.open(DipositEditorComponent, {
          width: '90%',
          height: '90%',
          closeOnNavigation: true,
          autoFocus: true,
          data: {
            'isDialog': true,
            'isReadOnly': false,
            'vehicleDiposit': row
          }
        });
        ref.afterClosed().subscribe(data =>{
          this.update();
        });
        });
    }
  }*/

  setDesperfecto(row_obj: DesperfectosDto) {
    row_obj.idDipositVehicle = Number(this.value.idDipositVehicle);
    this.dipositService.setDesperfectos(row_obj).subscribe(res => {
      this.loadDesperfectos();
    });
  }

  deleteDesperfecto(row_obj) {
    this.dipositService.deleteDesperfecto(row_obj).subscribe(res => {
      this.loadDesperfectos();
    });
  }
  viewImages(row_obj) {
    this.dipositService.getImages(row_obj.SomId, this.value.iddenuncia).subscribe( images => {
      this.denunciesImages = images;
      this.denunciesImages.forEach(element => {
        element.NUM_DENUNCIA = this.value.iddenuncia;
      });
//        this.denunciesImageDialogRef = this.dialog.open(PhotoBoxGruaComponent,
      var dialogPhoto = this.dialog.open(PhotoBoxGruaComponent,
      {
        minWidth: '50%',
        maxWidth: '90%',
        maxHeight: '70%',
        closeOnNavigation: false,
        autoFocus: true,
        data: {'ficheros': images, 'numDenuncia': this.value.iddenuncia, 'contenedor': row_obj.SomId, 'isDialog': true},
      });
      dialogPhoto.afterClosed().subscribe(() => {
          this.loadDesperfectos();
      });
      /*this.denunciesImageDialogRef.componentInstance.somid = this.value.iddenuncia;

      dialogPhoto.afterClosed().subscribe(() => {
        this.denunciesService.getDenunciaImages(numDenuncia).subscribe( newImages => {
          this.dataSource.getData().find(x => x.iddenuncia === numDenuncia).numImatges = newImages.length;
          this.denunciesImages = newImages;
          this.denunciesImages.forEach(element => {
            element.NUM_DENUNCIA = numDenuncia;
          });
        });
      });*/
    });
  }
}
